import {Component, EventEmitter, forwardRef, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {ListResponse} from '../../interface/response/list-response';
import {DOCUMENT} from '@angular/common';
import {debounceTime, delay, distinctUntilChanged, startWith, takeUntil} from 'rxjs/operators';
import {MatSelectChange} from '@angular/material/select';
import {Krk} from '../../interface/krk';
import {KrkService} from '../../services/krk.service';
import {Ofwca} from "../../interface/ofwca";
import {Registration} from "../../interface/registration";

@Component({
  selector: 'app-dict-krk',
  templateUrl: './dict-krk.component.html',
  styleUrls: ['./dict-krk.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => DictKrkComponent)}
  ]
})
export class DictKrkComponent implements  OnInit, OnDestroy, ControlValueAccessor {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  @Input() filterOfwcaKRK?: Ofwca;
  @Input() option?: string;
  @Input() register?: string;
  @Input() label: string;
  @Input() multiple = false;
  @Input() control: FormControl = null;
  @Input() required = false;

  externalControl = true;
  disabled = false;
  items: Krk[] = [];
  value?: string = null;
  ofwcaFilterCtrl: FormControl;
  itemsSubject: ReplaySubject<ListResponse<Krk>> = new ReplaySubject<ListResponse<Krk>>(1);
  krkDocuments = false;
  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(
    private krkService: KrkService,
    @Inject(DOCUMENT) private document: Document,
    private fb: FormBuilder,
  ) {
    this.ofwcaFilterCtrl = fb.control('');
  }

  ngOnInit(): void {
    if (this.control === null) {
      this.control = new FormControl('');
      this.externalControl = false;
    }
      this.control.valueChanges
        .pipe(
          startWith(this.control.value),
          takeUntil(this.destroyed$)
        )
        .subscribe((val: string) => {
          if (val) {
            let exists = false;
            this.items.forEach((krk: Krk) => {
              if (krk.uuid === val) {
                exists = true;
              }
            });

            if (!exists) {
              this.krkService.loadNotCountedList(0, 3, {
                uuid: val
              }, this.itemsSubject);
            }
          }
        });

    this.ofwcaFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(200),
        distinctUntilChanged(),
        takeUntil(this.destroyed$),
      )
      .subscribe((val) => {
        if (val) {
          this.krkService.loadNotCountedList(0, 20, {
            context: val,
          }, this.itemsSubject);
        } else if (this.control.value) {
          this.krkService.loadNotCountedList(0, 20, {
            uuid: this.control.value
          }, this.itemsSubject);
        }
      });

    this.itemsSubject
      .pipe(takeUntil(this.destroyed$)
      ).subscribe((result: ListResponse<Krk>) => {
        this.items = result.items;
      });
  }

  ngOnChanges(): void {
    if (this.filterOfwcaKRK) {
      this.krkService.loadNotCountedList(0, 10, {
        ofwca: this.filterOfwcaKRK.uuid
      }, this.itemsSubject);
      return;
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.externalControl) {
      return;
    }

    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }

    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    if (this.externalControl) {
      return;
    }

    this.control.setValue(value);
    this.value = value;
  }

  onSelectionChange(e: MatSelectChange): void {
    this.value = e.value;
    this.onChange(this.value);
  }

  clearValue(): void {
    this.control.setValue(this.multiple ? [] : '');
    this.writeValue(this.multiple ? [] : '');
    this.onChange(this.value);
  }

}
